import { FormattedMessage } from 'react-intl'

import { HeaderIconUnauthenticated } from 'components/Icons'
import { Card } from 'components/Layout'

import { IconContainer } from '../IconContainer'
import { Wrapper } from '../Wrapper'

export const Expired = () => (
	<Wrapper>
		<Card>
			<IconContainer>
				<h1>
					<FormattedMessage id='flow.expired.title' defaultMessage='Link is expired or already completed' />
				</h1>
				<HeaderIconUnauthenticated />
				<p>
					<FormattedMessage
						id='flow.expired.description'
						defaultMessage='It looks like the link has expired or you have already submitted your budget. Please reach out to your bank advisor if you believe this is a mistake.'
					/>
				</p>
			</IconContainer>
		</Card>
	</Wrapper>
)
